<template>
   <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title v-if="a != null">
          <div>{{ a.FirstName }} {{ a.LastName }} - {{$t('labels.Assets')}}</div>
        </v-card-title>

        <div style="margin: 1px 5px 5px 15px;">
          <div class="px-3" v-if="a != null">
            <v-row
              ><v-col><p v-if="app.ReqAssets && a.Assets.length == 0" v-html="$t('labels.ReqAssetDesc')"></p>
              <p v-else v-html="$t('labels.AssetDesc')"></p>
              </v-col
            ></v-row>

            <v-row>
              <v-col cols="12" v-if="a && a.Assets.length > 0">
                <v-simple-table v-if="a">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{$t('labels.AssetTypeheader')}}</th>
                        <th>{{$t('labels.Descriptionheader')}}</th>
                        <th>{{$t('labels.valueheader')}}</th>
                        <th class="text-right" width="150">
                          <span> </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in a.Assets" :key="item.AssetID">
                        <td>{{ item.strAssetType }}</td>
                        <td>{{ item.AssetDescription }}</td>
                        <td>{{ item.strAssetValue }}</td>
                        <td class="text-right">
                          <v-btn @click="edit(item.AssetID)" text small color="primary"><v-icon small>fas fa-edit</v-icon></v-btn>
                          <v-btn @click="del(item.AssetID)" text small color="red"><v-icon small>fas fa-trash-alt</v-icon></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12" v-else> </v-col>
            </v-row>
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-btn @click="back" color="grey lighten-1">{{ $t("labels.Back") }}</v-btn>
            <v-spacer />
            <v-btn @click="add" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.AddAsset')}}</v-btn>
            <v-btn :disabled="app.ReqAssets && a.Assets.length == 0" @click="next" color="primary">{{$t('labels.Next')}}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>

    <v-dialog  v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('labels.Assets')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="dialog">
            <small v-html="$t('labels.RequiredFieldsDesc')" />

            <v-row dense>
                <v-col cols="12" md="6">
                    <p_dd menu="AssetType" v-model="frm.AssetTypeDD" :label="$t('labels.AssetType')" />
                </v-col>
                <v-col cols="12" md="6">
                  <p_money v-model="frm.AssetValue" :label="$t('labels.AssetValue')" />
                  
                </v-col>
                <v-col cols="12">
                  <v-text-field type="text" v-model="frm.AssetDescription" :label="$t('labels.Description')" />
                </v-col>
            </v-row>
            
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogClose">{{$t('labels.Close')}}</v-btn>
          <v-btn color="blue darken-1" text @click="dialogSave">{{$t('labels.Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import p_dd from "@/shared/components/ddSelect";
import p_money from "@/shared/components/money";
export default {
components: { drawer, p_dd   ,p_money },
   data() {
    return {      
      frm: model.propertyModel(),      
      dialog: false,
      loadFlag: false,
      app: model.appModel(),
      a: null,
      applicantID: this.$route.params.applicantid,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false
    };
  },
  methods: {
    
    dialogClose() {
      this.dialog = false;
    },
    dialogSave() {
    
       
      if (!this.dialogValid()) return;

      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        Asset: this.frm,
        ApplicantID: this.a.ApplicantID
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPUpsertAsset", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) this.loadPage();
        });

      this.dialog = false;
    },

    dialogValid() {
      let asset = this.frm;
      
      if(asset.AssetTypeDD===null){
        this.$alert( this.$t('labels.Warning'), this.$t('errors.AssetMissingAssetType') );
        return false;
      }
      if(asset.AssetValue===null || asset.AssetValue<=0){
        this.$alert( this.$t('labels.Warning'), this.$t('errors.AssetMissingAssetValue') );
        return false;
      }

      return true;
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;

            for (let i = 0; i < this.app.Applicants.length; i++) {
              if (this.app.Applicants[i].ApplicantID == this.applicantID) {
                this.a = this.app.Applicants[i];
              }
            }
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
    back() {
       if(this.app.showProperty == true){
         this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/property");            
          }else if(this.app.showIncome == true && this.app.DisplayIncome == true){
            this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/income");    
          }else{
             this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/address");
          }    
    },
    add() {
      // clear
      this.frm = model.assetModel();       
      this.dialog = true;
    },
    del(assetID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteAsset"),
        () => {
          let postData = {
            SiteID: this.siteID,
            UserID: this.userID,
            MortgageApplicationID: this.mortgageApplicationID,
            ApplicantID: this.a.ApplicantID,
            AssetID: assetID
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/MTGAPPDeleteAsset", postData)
            .then(res => {
              this.loadFlag = false;
              this.loadPage();
            });
        },
        () => {}
      );
    },
    edit(assetID) {
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID,
        AssetID: assetID
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadAsset", postData)
        .then(res => {
          this.frm = res.data.Asset;
          this.loadFlag = false;
          this.dialog = true;
        });
    },
    next() {
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPDoneAsset", postData)
        .then(res => {
          this.loadFlag = false;
          if(this.app.showLiabilities == true){     
             this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/liability");
            }else{
              if(this.app.RequestReview == true && this.app.DisplayMortgage == true){
              this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/mortgage");
            }else if(this.app.RequestReview == true && this.app.DisplayMortgage == false){
              this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/summary");
            }else{
              this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/coApplicant");
            }
               
              }          
          //if(res.data.NextStep==''){
            //this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/mortgage");
            // this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/coApplicant");
          // } else {
          //   this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + res.data.ApplicantID + "/" + res.data.NextStep);
          // }
        });
    }
  },
  created() {    
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  }
}
</script> 